import React from "react";
import { Modal, Grid, FormInstance } from "antd";
import { ModalProps } from "antd/lib/modal";
import BaseProps from "../BaseProps/baseProps";
import { FormC } from "..";
import Form, { FormProps } from "antd/lib/form";
import Icon from "../IconAntD/icon";
import "./Modal.Component.less";

interface ModalComponentProps extends ModalProps, BaseProps {
	form?: FormProps;
	children: React.ReactNode;
	formFromOut?: FormInstance<any>;
}
const ModalComponent = (props: ModalComponentProps) => {
	const [form] = Form.useForm();
	const {
		inForm = true,
		form: forms,
		className,
		width,
		formFromOut = form,
	} = props;

	const { useBreakpoint } = Grid;
	const { sm, xs, lg, md, xl, xxl } = useBreakpoint();
	const component = (props: ModalComponentProps) => (
		<Modal
			centered
			closeIcon={
				<Icon
					type="CloseCircleOutlined"
					style={{ fontSize: "25px", verticalAlign: "-7px" }}
					className="cl-Primary"
				/>
			}
			{...props}
			width={!lg && !md && !xl && !xxl ? "95%" : width}
			className={`ModalComponent ${className}`}
		/>
	);

	if (inForm) {
		return component({
			onOk: () => formFromOut.submit(),
			...props,
			children: (
				<FormC form={formFromOut} {...forms} children={props.children} />
			),
		});
	}

	return component(props);
};

export default ModalComponent;
